export enum ELocalStorageKey {
  AccessToken = "accessToken",
  RefreshToken = "refreshToken",
}
